import {
    Stack,
    Typography,
    TextField,
    Button,
} from "@mui/material";

export default function StoreSettings() {
    return (
        <>
            <Typography
                sx={{
                    fontSize: 24,
                    fontWeight: 700,
                    mb: 0.5,
                }}
            >
                Store Settings
            </Typography>

            <Typography sx={{ color: "#777", mb: 4 }}>
                Manage your business information
            </Typography>

            <Stack spacing={3}>
                <TextField fullWidth label="Store Name" />

                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Store Address"
                />

                <TextField
                    fullWidth
                    label="Contact Number"
                />

                <Button
                    variant="contained"
                    sx={{
                        width: "fit-content",
                        backgroundColor: "#111",
                        borderRadius: 3,
                        textTransform: "none",
                    }}
                >
                    Save Changes
                </Button>
            </Stack>
        </>
    );
}